import { memo, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { BodyCopy } from "../components/BodyCopy";
import { Button, Layout, PageTitle } from "lola-framework-ui-test";
import { AuraLayout } from "../components/AuraLayout";
import { ErrorAlertIcon as ErrorIcon } from "../assets/icons";
import { FlowHeroMark } from "../components/FlowHeroMark";
import { useStore } from "../store/globalState";
import { useExitToPartnerOrLanding } from "../hooks/useExitToPartnerOrLanding";
import { getEvents, safeCapture } from "../analytics";
import { ScrollFadeIndicator } from "../components/ScrollFadeIndicator";

/** Confirmed list match. No shareable link exists. Same chrome as the other alerts. */
export const RequestReviewPage = memo(() => {
  const { t } = useTranslation();
  const { theme } = useStore();
  const { exitToPartnerOrLanding, canExitToPartner } = useExitToPartnerOrLanding();

  const colorConfig = theme.errorView;
  const { backgroundBtn, textColorBtn, title, bodyCopy, iconColors, backgroundIcon } =
    colorConfig;

  useEffect(() => {
    safeCapture(getEvents().SCREEN_VIEW("requester_review"));
  }, []);

  return (
    <AuraLayout colorConfig={colorConfig} className="flow-landing-page">
      <Layout.Content className="landing-section flow-hero-section">
        <ScrollFadeIndicator color={colorConfig.bodyCopy} />
        <section className="flow-hero">
          <FlowHeroMark backgroundIcon={backgroundIcon}>
            <ErrorIcon size={60} colors={iconColors} />
          </FlowHeroMark>
          <section className="landing-container">
            <PageTitle
              highlight={t("requesterScreening.reviewTitle")}
              highlightColor={title}
              secudnary=""
              secudnaryColor={title}
            />
            <BodyCopy textColor={bodyCopy}>
              {t("requesterScreening.reviewBody")}
            </BodyCopy>
          </section>
        </section>
      </Layout.Content>
      {canExitToPartner && (
        <Layout.Footer>
          <section className="footer-section">
            <Button
              size="large"
              background={backgroundBtn}
              color={textColorBtn}
              onClick={() => {
                safeCapture(getEvents().EXIT_CLICK, { screen: "requester_review" });
                exitToPartnerOrLanding();
              }}
            >
              {t("error.returnToApp")}
            </Button>
          </section>
        </Layout.Footer>
      )}
    </AuraLayout>
  );
});
